<template>
  <div class="app-page">
    <!--<div class="app-page-header">
      <img src="../assets/login/back.png" @click="back"/>
      <span class="title">智能信息发布设备安装</span>
      <img src="../assets/login/back.png" style="visibility: hidden"/>
    </div>-->
    <div class="app-page-content">
      <div class="app-card">
        <div class="form-item" @click="getStore">
          <div class="title">所属门店</div>
          <div class="arrow" v-if="store.storeId != -1">
            <span>{{store.storeName}}</span>
            <img src="../assets/login/arrow_right.png"/>
          </div>
          <div class="arrow" v-else>
            <span>请选择</span>
            <img src="../assets/login/arrow_right.png"/>
          </div>
          <store v-if="isStoreId" @choose="selected($event)" @back="getBack"></store>
        </div>
        <div class="form-item">
          <div class="title">设备序列号</div>
          <div class="arrow">
            <input type="number" class="xc-btn" name="deviceSerialNum" placeholder="请输入四位编码" maxlength="4"
                   v-model="deviceSerialNum" @input="validate"/>
          </div>
        </div>
        <div class="form-item" @click="getType">
          <div class="title">设备类型</div>
          <div class="arrow" v-if="deviceType==''">
            <span>请选择</span>
            <img src="../assets/login/arrow_right.png"/>
          </div>
          <div class="arrow" v-else>
            <span>{{deviceType}}</span>
            <img src="../assets/login/arrow_right.png"/>
          </div>
          <device-type v-if="isType" @choose="selected($event)" @close="closePopup"></device-type>
        </div>
        <div class="form-item">
          <div class="title">设备型号</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="model" placeholder="请输入设备型号" v-model="model "/>
          </div>
        </div>
        <div class="form-item">
          <div class="title">设备尺寸</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="screenSize" placeholder="请输入设备尺寸" v-model="screenSize "/>
          </div>
        </div>
        <div class="form-item">
          <div class="title">设备名称</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="deviceName" placeholder="请输入设备名称" v-model="deviceName "/>
          </div>
        </div>
        <div class="form-item">
          <div class="title">所在单元</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="unit" placeholder="请输入所在单元" v-model="unit "/>
          </div>
        </div>
        <div class="form-item">
          <div class="title">所在楼栋</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="building" placeholder="请输入所在楼栋" v-model="building "/>
          </div>
        </div>
        <div class="form-item">
          <div class="title">所在楼层</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="floor" placeholder="请输入所在楼层" v-model="floor "/>
          </div>
        </div>
        <div class="form-item">
          <div class="title">安装位置</div>
          <div class="arrow">
            <input type="text" class="xc-btn" name="position" placeholder="请输入位置标注" v-model="position "/>
          </div>
        </div>
      </div>
    </div>
    <div class="app-page-footer">
      <div class="save" @click="bind">
        保存并绑定
      </div>
    </div>
  </div>
</template>

<script>
  import deviceType from "../components/deviceType"
  import store from "../components/store"

  export default {
    name: 'bindDevice',
    data() {
      return {
        url: process.env.VUE_APP_BIND,
        deviceSerialNum: "", //设备编码
        deviceType: "",    //设备类型
        model:"", //设备型号
        screenSize:"",  //设备尺寸
        deviceName:"",  //设备名称
        isType: false, //设备类型状态
        unit:"",//单元
        building:"",  //楼栋
        floor: "", //设备楼层
        store: { //门店
          storeName: "",
          storeId: -1
        },
        isStoreId: false,  //门店状态
        position: "" //设备详细位置
      }
    },
    components: {
      deviceType,
      store,
    },
    created() {
      var devicecode = this.$route.query.devicecode;
      var uniqueDeviceCode = this.$route.query.uniqueDeviceCode;
      if(uniqueDeviceCode){
        devicecode=uniqueDeviceCode;
      }
      //存储devicecode
      if (devicecode) {
        //存储设备序列号
        this.$store.dispatch("setDeviceCode", devicecode);
      }
      //请求门店列表（测试token是否过期，若无效跳转到登录页面）
      if(localStorage.token){
        this.$http.post("/store/list",{
          pageNum:1,
          pageSize: 1,
          status:0
        },{}).then(v =>{

        }).catch(fail =>{
          this.$router.replace("/login")
        })
      }else {
        //没有token直接跳到登录页面
        this.$router.replace("/login")
      }
    },
    methods: {
      back: function () {
        this.$router.go(-1);
      },
      //限制设备序列号只能输入4个数字
      validate: function (e) {
        var value = e.target.value;
        if (value.length > 4) {
          this.deviceSerialNum = value.slice(0, 4)
        }
      },
      //获取设备类型
      getType: function () {
        this.isType = true;
      },
      //  获取门店
      getStore: function () {
        this.isStoreId = true;
      },
      //  处理返回
      getBack: function () {
        this.isStoreId = false;
      },
      //  关闭弹窗
      closePopup: function () {
        this.isType = false;
      },
      //  已选择数据
      selected: function (data) {
        switch (data.type) {
          case 0:
            this.isType = false;
            this.deviceType = data.deviceType;
            break;
          case 1:
            this.isStoreId = false;
            this.store.storeName = data.storeName;
            this.store.storeId = data.storeId;
            break;
          default:
            break;
        }
      },
      //  绑定终端
      bind: function () {
        var _this = this;
        if (this.deviceSerialNum.length == 0) {
          this.$message.warning("请输入设备编码");
          return;
        }
        if (this.deviceSerialNum.length != 4) {
          this.$message.warning("请输入4位编码");
          return;
        }
        if (this.deviceType == "") {
          this.$message.warning("请选择设备类型");
          return;
        }
        if (this.store.storeName == "") {
          this.$message.warning("请选择门店");
          return;
        }
        if (this.model == "") {
          this.$message.warning("请输入设备型号");
          return;
        }
        if (this.screenSize == "") {
          this.$message.warning("请输入设备尺寸");
          return;
        }
        if (this.deviceName == "") {
          this.$message.warning("请输入设备名称");
          return;
        }
        if (this.unit == "") {
          this.$message.warning("请输入所在单元");
          return;
        }
        if (this.building == "") {
          this.$message.warning("请输入所在楼栋");
          return;
        }
        if (this.floor == "") {
          this.$message.warning("请输入所在楼层");
          return;
        }
        if (this.position == "") {
          this.$message.warning("请选择安装位置");
          return;
        }
        //  绑定终端
        this.$http.post(_this.url, {
          "deviceSerialNum": _this.deviceSerialNum,
          "deviceType": _this.deviceType,
          "model":_this.model,
          "screenSize":_this.screenSize,
          "deviceName":_this.deviceName,
          "unit":_this.unit,
          "building":_this.building,
          "floor": _this.floor,
          "position": _this.position,
          "storeId": _this.store.storeId,
        }, {
          // url:"http://10.200.61.160:8102/ckclient/bind",
          headers: {
            devicecode: _this.$store.state.devicecode
          }
        }).then(function (res) {
          _this.$router.push("./success");
        }).catch(function (result) {
          _this.$router.push("./fail")
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-page {
    /*padding-top: 13.5px;*/
  }

  .app-page-content {
    .app-card {
      background: #ffffff;
      .form-item {
        height: 50.5px;
        padding: 0 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ececec;
        font-size: 15px;
        .title {
          color: #000000;
        }
        .arrow {
          display: flex;
          align-items: center;
          input {
            width: 105px;
            padding: 0;
            color: #999999;
            font-size: 15px;
            border: 0;
            text-align: right;
          }
          span {
            font-size: 15px;
            color: #999999;
            margin-right: 8px;
          }
          img {
            width: 11.5px;
            height: 11.5px;
          }
        }
      }
    }
  }

  .app-page-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .save {
      width: 100%;
      height: 45px;
      background-color: #1655bf;
      color: #ffffff;
      font-size: 17px;
      text-align: center;
      line-height: 45px;
    }
  }

</style>
<style lang="scss">
  .popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .6);
    z-index: 999;
    display: flex;
    flex-direction: column-reverse;
    .popup-content {
      background: #ffffff;
      .header {
        position: relative;
        line-height: 50.5px;
        border-bottom: 1px solid #ececec;
        font-weight: bold;
        font-size: 17px;
        img {
          width: 17px;
          position: absolute;
          right: 18px;
          top: 50%;
          margin-top: -8.5px;
        }
      }
      .content {
        height: 101px;
        overflow: scroll;
      }
    }
  }

  .form-item {
    height: 50.5px;
    padding: 0 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ececec;
    font-size: 15px;
  }
</style>
